import { Component, Injector, Input, OnInit } from '@angular/core';
import { SeriesAmateursDetailItem } from 'world-archery-lib';
import { DrupalLangClass } from '../../../../common-page-components/classes/drupal-lang-class';

@Component({
  selector: 'app-world-ranking-details',
  templateUrl: './world-ranking-details.component.html',
  styleUrls: ['./world-ranking-details.component.scss']
})
export class WorldRankingDetailsComponent extends DrupalLangClass implements OnInit {
  @Input()
  details: Array<any> = [];
  constructor(
    injector: Injector,
  ) {
    super(injector);

  }
  ngOnInit() {

  }
  calculate_medals(position: number) {
    if (position === 1) {
      return 'medal-gold';
    }
    if (position === 2) {
      return 'medal-silver';
    }
    if (position === 3) {
      return 'medal-bronze';
    }
  }
  calculatePosition(position: number) {
    const posString = position.toString();
    switch (posString.slice(posString.length - 1, posString.length)) {
      case '1':
        return 'st'
      case '2':
        return 'nd'
      case '3':
        return 'rd'
      default:
        return 'th'
    }
  }
  get included(): Array<SeriesAmateursDetailItem> {
    return this.details.filter((value: any) => value.InTotal === true);
  }
  get notincluded(): Array<SeriesAmateursDetailItem> {
    return this.details.filter((value: any) => value.InTotal === false);
  }
}
